import React from 'react';
import SafeIcon from '../common/SafeIcon';
import BrandMark from './BrandMark';
import { FiFolder, FiHash, FiSettings, FiPlus, FiGrid, FiShare2, FiPlayCircle, FiInfo } from 'react-icons/fi';

const Sidebar = ({ folders, tags, activeView, setActiveView }) => {
  return (
    <div className="w-64 h-full bg-paper-light border-r border-paper-dark flex flex-col hide-scrollbar overflow-y-auto shrink-0 select-none">
      {/* Brand */}
      <div className="p-6 flex items-center gap-3">
        <BrandMark className="w-9 h-9" />
        <div className="flex flex-col">
          <span className="font-black text-xl tracking-tight text-ink leading-none">MindMaple</span>
          <span className="text-[10px] font-bold text-maple uppercase tracking-widest mt-1">Spatial Engine</span>
        </div>
      </div>

      {/* Main Nav */}
      <div className="px-4 mb-8">
        <div className="space-y-1">
          <button 
            onClick={() => setActiveView('canvas')}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-bold transition-all ${activeView === 'canvas' ? 'bg-maple-soft text-maple shadow-sm' : 'text-ink-light hover:bg-paper-dark/50'}`}
          >
            <SafeIcon icon={FiGrid} className="w-4 h-4" /> Idea Canvas
          </button>
          <button 
            onClick={() => setActiveView('graph')}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-bold transition-all ${activeView === 'graph' ? 'bg-maple-soft text-maple shadow-sm' : 'text-ink-light hover:bg-paper-dark/50'}`}
          >
            <SafeIcon icon={FiShare2} className="w-4 h-4" /> Link Graph
          </button>
          <button 
            onClick={() => setActiveView('demo')}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-bold transition-all ${activeView === 'demo' ? 'bg-maple-soft text-maple shadow-sm' : 'text-ink-light hover:bg-paper-dark/50'}`}
          >
            <SafeIcon icon={FiPlayCircle} className="w-4 h-4" /> Product Hub
          </button>
        </div>
      </div>

      {/* Folders */}
      <div className="px-4 mb-8">
        <div className="flex items-center justify-between mb-3 px-3">
          <span className="text-[10px] font-black text-ink-muted uppercase tracking-[0.2em]">Workspaces</span>
          <button className="text-ink-muted hover:text-maple transition-colors"><SafeIcon icon={FiPlus} className="w-3.5 h-3.5" /></button>
        </div>
        <div className="space-y-1">
          {folders.map(folder => (
            <button key={folder.id} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium text-ink-light hover:bg-paper-dark/50 transition-colors group">
              <SafeIcon icon={FiFolder} className="w-4 h-4 text-ink-muted group-hover:text-maple transition-colors" />
              <span className="truncate">{folder.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tags */}
      <div className="px-4 mb-auto">
        <div className="flex items-center justify-between mb-3 px-3">
          <span className="text-[10px] font-black text-ink-muted uppercase tracking-[0.2em]">Contexts</span>
        </div>
        <div className="space-y-1">
          {tags.map(tag => (
            <button key={tag.name} className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm font-medium text-ink-light hover:bg-paper-dark/50 transition-colors group">
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiHash} className="w-4 h-4 text-ink-muted group-hover:text-maple transition-colors" />
                <span>{tag.name}</span>
              </div>
              <span className="text-[10px] font-bold bg-paper-dark text-ink-muted px-2 py-0.5 rounded-md">{tag.count}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Footer / Settings */}
      <div className="p-4 border-t border-paper-dark mt-4 bg-paper-light">
        <button className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-bold text-ink-light hover:bg-paper-dark/50 transition-colors mb-4">
          <SafeIcon icon={FiSettings} /> Settings
        </button>
        <div className="px-3 flex flex-col gap-2">
          <div className="flex items-center gap-2 opacity-40 grayscale group hover:grayscale-0 hover:opacity-100 transition-all">
             <BrandMark className="w-4 h-4" />
             <span className="text-[9px] font-black uppercase tracking-widest text-ink">MindMaple v2.4</span>
          </div>
          <div className="text-[9px] text-ink-muted/60 font-medium leading-tight">
            Made by LingLink AI and DigLab AI
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;